import React, { useEffect } from 'react'
import ReactModal from 'react-modal'
import { Box, SxProp } from 'theme-ui'

import BaseButton from 'src/components/common/buttons/BaseButton'

type ComponentProps = SxProp & ReactModal['props']

interface Props extends ComponentProps {
  closeModal: (event: React.SyntheticEvent) => void
  title?: React.ReactNode
}

const Modal = ({ closeModal, title, children, ...rest }: Props) => {
  useEffect(() => {
    // http://reactcommunity.org/react-modal/accessibility
    const nextElement = document.getElementById('__next') || document.getElementById('root') || ''
    nextElement !== '' && ReactModal.setAppElement(nextElement)
  }, [])

  return (
    <ReactModal
      onRequestClose={closeModal}
      closeTimeoutMS={300}
      overlayClassName="ReactModal__ListsOverlay"
      style={{
        overlay: {
          position: 'fixed',
          backgroundColor: 'rgba(0, 0, 0, 0.60)',
          zIndex: 200,
          top: '80px',
          left: '0px',
          right: '0px',
          bottom: '0px'
        },
        content: {
          inset: '16px',
          maxWidth: '900px',
          margin: 'auto',
          height: 'fit-content'
        }
      }}
      {...rest}
    >
      {title && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: [3, null, 4]
          }}
        >
          <>
            {title}
            <BaseButton onClick={closeModal} leftIcon="GelIconClose" variant="buttons.tertiary" />
          </>
        </Box>
      )}
      <Box className="tabFocusBlue">{children}</Box>
    </ReactModal>
  )
}

export default Modal
